import type { ActivityDetailResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { dateFormatter } from "web_myplann/Shared/Utils/formatters";

export const useFormatDateAndTimes = () => {
	const { t } = useResource();

	return (
		dateFrom: string | null | undefined,
		timeF: string | null | undefined,
		timeT: string | null | undefined,
	): string => {
		if (!dateFrom) return "";
		const dateStr = dateFormatter(dateFrom);
		const from = timeF?.slice(0, -3);
		const to = timeT?.slice(0, -3);
		if (from && to) return `${dateStr} ${from} - ${to}`;
		if (from) return `${dateStr} ${t(Resources.Activity.List.From)} ${from}`;
		if (to) return `${dateStr} ${t(Resources.Activity.List.To)} ${to}`;
		return dateStr;
	};
};

export const useFormatDateTimeByClientActivity = () => {
	const formatDateAndTimes = useFormatDateAndTimes();

	return (dataEvent: ActivityDetailResponseDTO) => {
		return formatDateAndTimes(
			dataEvent?.date,
			dataEvent?.timeFrom,
			dataEvent?.timeTo,
		);
	};
};
